export default __webpack_public_path__ + "static/media/lock.a5c3cb65.svg";